import React from "react";
import { useEffect, useState } from "react";
import cookie from "react-cookies";
import { getPastOrderStatusRashan } from "../Request/OrderRequests";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { openCatDD } from "../Redux/Reducer/dropdown";
export default function MenuBar({ active }) {
  const navigate = useNavigate();
  const [pastOrders, SetpastOrders] = useState(0);
  const user = useSelector((s) => s.user.info);
  const tabs = {
    Home: { icon: "bi-house-fill", link: "/home" },
    Categories: { icon: "bi-clipboard-data", link: "/Atta, Rice & Dal" },
    // Orders: { icon: "bi-file-text", link: "/orders" },
    Account: { icon: "bi-person-circle", link: "/account" },
  };
  const dispatch = useDispatch();

  useEffect(() => {
    if (user?.userHash) {
      getPastOrderStatusRashan(cookie.load("uid"))
        .then((res) => SetpastOrders(res?.[0]?.pastOrder || 0))
        .catch((err) => console.log(err));
    }
  }, [user]);
  return (
    <div
      className="d-flex bg-white fixed-bottom bottom-navbar"
      style={{
      }}
    >
      {Object.keys(tabs).map((tab, i) => (
        <div
          key={i}
          style={{
            width: "56px",
            color: active == tab ? "#F88001" : "#444444",
          }}
          className={
            "d-flex flex-column text-center lh-sm pointer " +
            (active === tab ? "active" : "")
          }
          onClick={() => {
            dispatch(openCatDD());
            navigate(tabs[tab].link);
          }}
        >
          <div
            className={tabs[tab].icon + " mx-auto icon-menu"}
            style={{
              width: "24px",
              height: "24px",
              fontSize: "24px",
              lineHeight: "24px",
            }}
          >
            {tab === "Orders" && pastOrders !== 0 ? (
              <>
                <span
                  className="position-absolute translate-middle badge rounded-pill bg-danger"
                  style={{
                    padding: "3px",
                    paddingLeft: "3px",
                    paddingRight: "3px",
                    marginTop: "5px",
                    marginLeft: "0px",
                  }}
                >
                  {/* <div className="fs-md" style={{ padding: "1.2px" }}> */}
                  <div className="" style={{ fontSize: "24px" }}>
                    {pastOrders}
                  </div>
                </span>
              </>
            ) : (
              ""
            )}
          </div>
          <span
            style={{
              fontSize: "11px",
              lineHeight: "14px",
              fontWeight: active == tab ? "700" : "500",
            }}
          >
            {tab}
          </span>
        </div>
      ))}
    </div>
  );
}
